<template>
  <v-app class="app">
    <UserIdentify v-if="!$auth.loading && $auth.isAuthenticated" />
    <Header />
    <v-main class="main-container">
      <skeleton-app
        :loading="pageLoading.loading || $auth.loading"
        :path="pageLoading.path"
      >
        <router-view />
      </skeleton-app>
    </v-main>
    <Footer />

    <div v-if="!isProductionMode" class="fab-mock-btn">
      <v-btn outlined :color="mockIconColor" fab @click="toggleMock">
        <v-icon :color="mockIconColor"> mdi-connection </v-icon>
      </v-btn>
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { REDIRECT_VALID_DOMAINS, LS_PREVIOUS_LINK_KEY } from './constants';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import SkeletonApp from './components/skeleton/App';
import UserIdentify from './components/UserIdentify.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SkeletonApp,
    UserIdentify,
  },
  data: () => ({
    isProductionMode: process.env.VUE_APP_IS_PRODUCTION === 'true',
  }),
  computed: {
    ...mapGetters(['pageLoading', 'apiMockEnabled']),
    mockIconColor() {
      return this.apiMockEnabled ? 'primary' : 'black';
    },
  },
  async mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);

    try {
      // just checks if it's a valid URL
      const prevUrl = new URL(document.referrer);
      if (
        !prevUrl.href.includes(window.location.host) &&
        REDIRECT_VALID_DOMAINS.map(d => prevUrl.href.includes(d)).some(Boolean)
      ) {
        window.localStorage.setItem(LS_PREVIOUS_LINK_KEY, JSON.stringify({
          link: prevUrl.href,
          expires: new Date().setFullYear(new Date().getFullYear() + 1),
        }));
      }
    // intentional empty catch
    // eslint-disable-next-line
    } catch (_) { }
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    ...mapActions(['updateWindowWidth']),
    resize() {
      this.updateWindowWidth(window.innerWidth);
    },
    toggleMock() {
      localStorage.setItem(
        'api-mock-enabled',
        (!this.apiMockEnabled).toString()
      );
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.fab-mock-btn {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 100;
  button {
    background: white;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  }
}
</style>

<style>
html,
body {
  scroll-behavior: smooth;
}
.app {
  background-color: #f6f7f8 !important;
}
.card {
  border: 0 !important;
}
.card-skeleton {
  background-color: white;
  box-shadow: 0px 3px 1px -2px #00000033, 0px 2px 2px 0px #00000024,
    0px 1px 5px 0px #0000001f;
  border-radius: 2px;
  padding: 0.5rem !important;
  margin: 0px 10px;
  min-height: 150px;
}
.app .v-expansion-panel-header > .v-expansion-panel-header__icon > i {
  color: #424540 !important;
}
.app .v-expansion-panel-header--active > .v-expansion-panel-header__icon > i {
  color: var(--v-primary-base) !important;
}
.app .v-alert.error {
  background-color: var(--v-error-lighten2) !important;
  border-color: var(--v-error-lighten2) !important;
  position: fixed;
  bottom: 30px;
  z-index: 99;
  left: 20px;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__heading {
  background: #e4e6eb !important;
}
.header-loading-1 > .v-skeleton-loader__heading {
  height: 32px;
  margin-top: 54px;
}
.header-loading-2 > .v-skeleton-loader__heading {
  height: 19px;
  width: 290px;
  margin-bottom: 4px;
}
.header-full-width > .v-skeleton-loader__heading {
  width: 318px;
}
.skeleton-foundational-reports,
.skeleton-methodology,
.skeleton-resources {
  overflow: hidden;
}
.skeleton-foundational-reports > div {
  width: calc(50% - 8px);
  margin-right: 0 !important;
  flex-basis: auto;
  margin-bottom: 16px;
  height: 138px;
}
@media (max-width: 1263px) {
  .skeleton-foundational-reports > div,
  .skeleton-methodology > div,
  .skeleton-resources > div {
    width: 290px;
    flex: none;
    margin-right: 16px !important;
  }
}
.skeleton-card-resources > div {
  height: 180px;
}
.skeleton-foundational-reports > div:nth-child(odd) {
  margin-right: 16px !important;
}
.skeleton-helpful-hints {
  flex-wrap: nowrap !important;
  overflow: hidden;
}
.skeleton-methodology {
  margin-bottom: 60px;
}
.skeleton-methodology .card-avatar-skeleton-card {
  height: 210px;
}
.padding-left-right {
  padding-left: 2rem;
  padding-right: 2rem;
}
.main-container {
  margin-bottom: 200px;
}
@media (max-width: 600px) {
  .padding-left-right {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.scroll-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
}

.scroll-wrapper .scroll-wrapper__content .card {
  float: left !important;
  width: 222px !important;
  box-shadow: none;
  border: 0;
}
.scroll-wrapper .scroll-wrapper__content .v-card__text {
  font-size: 12px !important;
}

.scroll-wrapper .scroll-wrapper__content .card .v-image__image {
  width: 65px;
  height: 65px;
}
@media screen and (max-width: 600px) {
  .scroll-wrapper .scroll-wrapper__content .card .card__btn {
    width: 100% !important;
  }
}
</style>
